export enum DatasetGeometryType {
    NONE = 'NONE',
    POINT = 'POINT',
    COMPLEX = 'COMPLEX',
    LINE_STRING = 'LINE_STRING'
    // VIRTUAL_POINT = 'VIRTUAL_POINT',
    // VIRTUAL_COMPLEX = 'VIRTUAL_COMPLE'
}
